if (!customElements.get('shipping-bar')) {
  customElements.define(
    'shipping-bar',
    class ShippingBar extends HTMLElement {
      static get observedAttributes() {
        return ['updated-value'];
      }

      constructor() {
        super();
        this.init();
      }

      init() {
        this.amount_els = this.querySelectorAll('.value');
        this.cartDraw =
          this.closest('cart-drawer') ||
          this.closest('.ca__free-shipping') ||
          this.closest('.main-cart') ||
          this.closest('.product');

        this.inner_bar = this.querySelector('.sb__bar .inner');

        if (!this.cartDraw) return; //attached to cartDraw as rest gets rebuilt

        var tier_data_el = this.querySelector('.gwp_tier_data');
        this.tier_data = [];

        if (tier_data_el) {
          this.tier_data = JSON.parse(
            tier_data_el.content.textContent ?? this.tier_data.innerText,
          );
        }

        this.setSize();

        //check collisons with tier to check off or cross out
        this.tiers = this.querySelectorAll('.bar-tier');
        if (this.tiers[0] && this.inner_bar) {
          //TODO make more efficient
          requestAnimationFrame(this.collisionCheck.bind(this));
        }
      }

      collisionCheck() {
        for (let i = 0; i < Array.from(this.tiers).length; i++) {
          const tier_el = this.tiers[i];

          const over_limit =
            this.inner_bar.getBoundingClientRect().right >
            tier_el.getBoundingClientRect().right;

          tier_el.dataset.over = over_limit;

          this.handleTierCopy(tier_el.dataset.index, over_limit);
        }

        requestAnimationFrame(this.collisionCheck.bind(this));
      }

      handleTierCopy(index, isOver) {
        var matching_copy_el = this.querySelector(
          `.tier-copy[data-index="${index}"]`,
        );

        if (!matching_copy_el) return;

        matching_copy_el.dataset.over = isOver;
      }

      setSize() {
        var limit = parseInt(this.dataset.limit);
        var total_value = this.dataset.cartTotalFe ?? this.dataset.cartTotal;
        var total = this.dataset.potentialItems
          ? parseInt(total_value) + parseInt(this.dataset.potentialItems)
          : parseInt(total_value);

        var distance = (total / limit) * 100;

        var current_location =
          document.querySelector('main')?.dataset.location ?? 'en';
        var current_currency =
          document.querySelector('main')?.dataset.currency ?? 'AUD';

        //new shipping bar uses server side logic to handle value, capp stil needs client side
        Array.from(this.amount_els).forEach((amount_el) => {
          let money = new Intl.NumberFormat(current_location, {
            style: 'currency',
            currency: current_currency,
            currencyDisplay: 'narrowSymbol',
          });
          //amount_el.innerHTML = Shopify.formatMoney(limit - total);
          amount_el.innerHTML = money.format((limit - total) / 100);
        });

        //set size property on cart draw as the rest gets replaced
        setTimeout(() => {
          //timeout to ensure element has be rendered
          this.cartDraw.style.setProperty(
            '--shipping-distance',
            `${distance > 100 ? 100 : distance}%`,
          );
          this.cartDraw.dataset.distance = distance > 100 ? 100 : distance;
        }, 0);

        if (this.tier_data?.length > 0) {
          this.setCopy(limit, total);
        }
      }

      setCopy(limit, total) {
        var current_tier = false;
        var current_tier_limit = 0;

        this.tier_data.forEach((tier) => {
          var limit_cents = parseInt(tier.limit * 100);

          if (total <= limit_cents) {
            current_tier = tier;
            current_tier_limit = limit_cents;
          }
        });

        if (!current_tier) {
          //over?
        }

        var icon_el = this.querySelector('.icon:not(.icon--over)');
        var under_el = this.querySelector('.under');
        var dom_parser = new DOMParser();

        //DOESNT HANDLE GWP
        if (icon_el && current_tier.top_icon) {
          icon_el.innerHTML = current_tier.top_icon;
        }

        if (under_el && current_tier.top_copy) {
          var distanct_to_tier = current_tier_limit - total;

          var current_location =
            document.querySelector('main')?.dataset.location ?? 'en';
          var current_currency =
            document.querySelector('main')?.dataset.currency ?? 'AUD';

          var money = new Intl.NumberFormat(current_location, {
            style: 'currency',
            currency: current_currency,
            currencyDisplay: 'narrowSymbol',
          });

          var value_replaced = current_tier.top_copy.replaceAll(
            '[value]',
            money.format(distanct_to_tier / 100),
          );

          if (this.hasAttribute('data-exclude-price')) {
            value_replaced = current_tier.top_copy.replaceAll(
              '[value]',
              distanct_to_tier / 100,
            );
          }
          under_el.innerHTML = this.decodeHtmlEntities(value_replaced);
        }
      }
      decodeHtmlEntities(text) {
        // Create a temporary textarea element to do the decoding
        const textArea = document.createElement('textarea');
        textArea.innerHTML = text;
        return textArea.value;
      }
      attributeChangedCallback(name, oldValue, newValue) {
        if (!this.cartDraw) return; //attached to cartDraw as rest gets rebuilt

        if (oldValue === newValue) return;

        if (name === 'updated-value') {
          this.dataset.cartTotal = newValue;
          this.setSize();
        }
      }
    },
  );
}
